// extracted by mini-css-extract-plugin
module.exports = {"name":"Client_name__3k7XD","owner":"Client_owner__33Nt1","clientLink":"Client_client-link__30CPX"};